import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  PUBLIC_HOLIDAY_LIST_REQUEST,
  PUBLIC_HOLIDAY_LIST_SUCCESS,
  PUBLIC_HOLIDAY_LIST_FAILURE,
  PUBLIC_HOLIDAY_LIST_RESET,
  PUBLIC_HOLIDAY_CREATE_REQUEST,
  PUBLIC_HOLIDAY_CREATE_SUCCESS,
  PUBLIC_HOLIDAY_CREATE_FAILURE,
  PUBLIC_HOLIDAY_CREATE_RESET,
  PUBLIC_HOLIDAY_GET_REQUEST,
  PUBLIC_HOLIDAY_GET_SUCCESS,
  PUBLIC_HOLIDAY_GET_FAILURE,
  PUBLIC_HOLIDAY_GET_RESET,
  PUBLIC_HOLIDAY_EDIT_REQUEST,
  PUBLIC_HOLIDAY_EDIT_SUCCESS,
  PUBLIC_HOLIDAY_EDIT_FAILURE,
  PUBLIC_HOLIDAY_EDIT_RESET,
  PUBLIC_HOLIDAY_DELETE_REQUEST,
  PUBLIC_HOLIDAY_DELETE_SUCCESS,
  PUBLIC_HOLIDAY_DELETE_FAILURE,
  PUBLIC_HOLIDAY_DELETE_RESET,
  PUBLIC_HOLIDAY_EXPORT_REQUEST,
  PUBLIC_HOLIDAY_EXPORT_SUCCESS,
  PUBLIC_HOLIDAY_EXPORT_FAILURE,
  PUBLIC_HOLIDAY_EXPORT_RESET,
} from './../../constants'

export function createPublicHoliday(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/public-holiday-calendars`,
      method: 'POST',
      types: [
        PUBLIC_HOLIDAY_CREATE_REQUEST,
        PUBLIC_HOLIDAY_CREATE_SUCCESS,
        PUBLIC_HOLIDAY_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getPublicHoliday(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/public-holiday-calendars`,
      method: 'GET',
      types: [
        PUBLIC_HOLIDAY_LIST_REQUEST,
        PUBLIC_HOLIDAY_LIST_SUCCESS,
        PUBLIC_HOLIDAY_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getPublicHolidayByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/public-holiday-calendars/${id}`,
      method: 'GET',
      types: [
        PUBLIC_HOLIDAY_GET_REQUEST,
        PUBLIC_HOLIDAY_GET_SUCCESS,
        PUBLIC_HOLIDAY_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editPublicHoliday(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/public-holiday-calendars/${id}`,
      method: 'PUT',
      types: [
        PUBLIC_HOLIDAY_EDIT_REQUEST,
        PUBLIC_HOLIDAY_EDIT_SUCCESS,
        PUBLIC_HOLIDAY_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deletePublicHoliday(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/public-holiday-calendars/${id}/delete`,
      method: 'PUT',
      types: [
        PUBLIC_HOLIDAY_DELETE_REQUEST,
        PUBLIC_HOLIDAY_DELETE_SUCCESS,
        PUBLIC_HOLIDAY_DELETE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportPublicHoliday(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/public-holiday-calendars/exports`,
      method: 'GET',
      types: [
        PUBLIC_HOLIDAY_EXPORT_REQUEST,
        PUBLIC_HOLIDAY_EXPORT_SUCCESS,
        PUBLIC_HOLIDAY_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

// export function exportCompany(access_token) {
//   return {
//     [CALL_API]: {
//       endpoint: `${BASE_URL}/companys/exports`,
//       method: 'GET',
//       types: [
//         COMPANY_EXPORT_REQUEST,
//         COMPANY_EXPORT_SUCCESS,
//         COMPANY_EXPORT_FAILURE,
//       ],
//       headers: {
//         'authorization': `bearer ${access_token}`,
//       },
//     },
//   }
// }
export function resetGetPublicHoliday() {
  return {
    type: PUBLIC_HOLIDAY_LIST_RESET,
  }
}
export function resetGetPublicHolidayByID() {
  return {
    type: PUBLIC_HOLIDAY_GET_RESET,
  }
}

export function resetCreatePublicHoliday() {
  return {
    type: PUBLIC_HOLIDAY_CREATE_RESET,
  }
}
export function resetEditPublicHoliday() {
  return {
    type: PUBLIC_HOLIDAY_EDIT_RESET,
  }
}
export function resetDeletePublicHoliday() {
  return {
    type: PUBLIC_HOLIDAY_DELETE_RESET,
  }
}
export function resetExportPublicHoliday() {
  return {
    type: PUBLIC_HOLIDAY_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/public-holiday/public-holiday-action.js